var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.877 15.205a.624.624 0 0 0 .528.955h7.124a.3.3 0 0 1 .252.458L8.792 27.81a.25.25 0 0 1-.352.077 14.08 14.08 0 0 1-1.063-22.89A14.054 14.054 0 0 1 15.62 2a.246.246 0 0 1 .213.379L7.877 15.204zm21.699.74a14.075 14.075 0 0 1-3.887 9.713A14.055 14.055 0 0 1 16.176 30a.198.198 0 0 1-.205-.2c0-.036.01-.07.03-.101l8.054-12.897a.626.626 0 0 0-.528-.956h-7.122a.297.297 0 0 1-.252-.456l6.887-11.024a.25.25 0 0 1 .353-.074 14.05 14.05 0 0 1 6.183 11.654z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.782 15.52a.624.624 0 0 1 .095-.315L15.833 2.38a.247.247 0 0 0-.213-.38 14.054 14.054 0 0 0-8.243 2.997 14.07 14.07 0 0 0-4.458 16.07c1.066 2.805 3 5.194 5.52 6.82a.248.248 0 0 0 .352-.077l6.99-11.192a.3.3 0 0 0-.253-.458H8.404a.622.622 0 0 1-.623-.64z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.689 25.658a14.075 14.075 0 0 0-2.297-21.366.248.248 0 0 0-.352.074l-6.886 11.025a.297.297 0 0 0 .252.457h7.122a.623.623 0 0 1 .623.642.626.626 0 0 1-.094.313L16.001 29.7a.198.198 0 0 0 .074.276.198.198 0 0 0 .103.024 14.055 14.055 0 0 0 9.512-4.342z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTt);
export default __webpack_public_path__ + "static/media/TT.e4cfd473ed52962820859ae185440630.svg";
export { ForwardRef as ReactComponent };